<template>
<div class="chapter">
<div class="inner_page">
<p class="part-tit"><strong>The Book of <br/>JEREMIAH</strong></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 010_Part.vue?6dcbce55